import ReactDOM from 'react-dom';
import App from './App';
import './global.css';

const app = document.getElementById('app');
ReactDOM.render(<App />, app);
